import "slick-carousel/slick/slick";


if (jQuery(".hero-background-sliderv4").length >= 1) {

	jQuery(document).ready(function () {
		jQuery(".hero-background-sliderv4").slick({
			slidesToShow: 1,
			arrows: true,
			prevArrow: jQuery(".hero__prev"),
			nextArrow: jQuery(".hero__next"),
			dots: true,
			focusOnSelect: true,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		});
	});
}

